/*
 * @Author: bbqin
 * @Date: 2022-10-20 13:38:00
 * @LastEditTime: 2022-10-20 13:38:01
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\libs\dnd\itemTypes.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
export const ItemTypes = { ITEM: 'item' };